import { memo, useState, useCallback } from 'react';
// @mui
import List from '@mui/material/List';
import Stack from '@mui/material/Stack';
import Collapse from '@mui/material/Collapse';
//
import { Colors } from 'src/theme/palette';
import { NavSectionProps, NavListProps, NavConfigProps } from '../types';
import { navVerticalConfig } from '../config';
import { StyledSubheader } from './styles';

import NavList from './nav-list';

// ----------------------------------------------------------------------

function NavSectionVertical({ data, config, sx, collapsedDisplay, ...other }: NavSectionProps & {collapsedDisplay?: boolean}) {
  return (
    <Stack sx={sx} {...other}>
      {data.map((group, index) => (
        <Group
          key={group.subheader || index}
          showSubheader={group.showSubheader}
          subheader={group.subheader}
          items={group.items}
          collapsedDisplay={collapsedDisplay}
          config={navVerticalConfig(config)}
        />
      ))}
    </Stack>
  );
}

export default memo(NavSectionVertical);

// ----------------------------------------------------------------------

type GroupProps = {
  subheader: string;
  items: NavListProps[];
  showSubheader?: boolean;
  config: NavConfigProps;
  collapsedDisplay?: boolean;
};

function Group({ subheader, items, config, showSubheader = false, collapsedDisplay = false }: GroupProps) {
  const [open, setOpen] = useState(true);

  const handleToggle = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  const renderContent = items.map((list) => (
    <NavList
      key={list.title + list.path}
      data={list}
      depth={1}
      hasChild={!!list.children}
      config={config}
      collapsedDisplay={collapsedDisplay}
    />
  ));

  return (
    <List disablePadding sx={{ px: 2 }}>
      {subheader ? (
        <>
          {/* SUBSECTIONS HIDDEN FOR NOW */}
          {!collapsedDisplay && showSubheader && <StyledSubheader disableGutters disableSticky onClick={handleToggle} config={config} sx={{color: Colors.greyText, pb: 0}}>
            {subheader}
          </StyledSubheader> }

          <Collapse in={open}>{renderContent}</Collapse>
        </>
      ) : (
        renderContent
      )}
    </List>
  );
}
